// extracted by mini-css-extract-plugin
export default {"commandName":"QueuedTaskRowNameCell-commandName-wXKoI","userAgent":"QueuedTaskRowNameCell-userAgent-EbkpU"};